export default __webpack_public_path__ + "static/media/332.6730f8ea.jpg";